import { render, staticRenderFns } from "./ForgotPasswordEmailSentForm.vue?vue&type=template&id=16f78b5e&scoped=true&"
import script from "./ForgotPasswordEmailSentForm.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordEmailSentForm.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordEmailSentForm.vue?vue&type=style&index=0&id=16f78b5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f78b5e",
  null
  
)

export default component.exports